export default {
  // Get all live videos
  GET_SUPERADMIN_LIVE_VIDEOS_REQUEST: "GET_SUPERADMIN_LIVE_VIDEOS_REQUEST",
  GET_SUPERADMIN_LIVE_VIDEOS_SUCCESS: "GET_SUPERADMIN_LIVE_VIDEOS_SUCCESS",
  GET_SUPERADMIN_LIVE_VIDEOS_FAIL: "GET_SUPERADMIN_LIVE_VIDEOS_FAIL",

  // Get live video by ID
  GET_SUPERADMIN_LIVE_VIDEO_BY_ID_REQUEST: "GET_SUPERADMIN_LIVE_VIDEO_BY_ID_REQUEST",
  GET_SUPERADMIN_LIVE_VIDEO_BY_ID_SUCCESS: "GET_SUPERADMIN_LIVE_VIDEO_BY_ID_SUCCESS",
  GET_SUPERADMIN_LIVE_VIDEO_BY_ID_FAIL: "GET_SUPERADMIN_LIVE_VIDEO_BY_ID_FAIL",

  // Create live video
  CREATE_SUPERADMIN_LIVE_VIDEO_REQUEST: "CREATE_SUPERADMIN_LIVE_VIDEO_REQUEST",
  CREATE_SUPERADMIN_LIVE_VIDEO_SUCCESS: "CREATE_SUPERADMIN_LIVE_VIDEO_SUCCESS",
  CREATE_SUPERADMIN_LIVE_VIDEO_FAIL: "CREATE_SUPERADMIN_LIVE_VIDEO_FAIL",

  // Update live video
  UPDATE_SUPERADMIN_LIVE_VIDEO_REQUEST: "UPDATE_SUPERADMIN_LIVE_VIDEO_REQUEST",
  UPDATE_SUPERADMIN_LIVE_VIDEO_SUCCESS: "UPDATE_SUPERADMIN_LIVE_VIDEO_SUCCESS",
  UPDATE_SUPERADMIN_LIVE_VIDEO_FAIL: "UPDATE_SUPERADMIN_LIVE_VIDEO_FAIL",

  // Delete live video
  DELETE_SUPERADMIN_LIVE_VIDEO_REQUEST: "DELETE_SUPERADMIN_LIVE_VIDEO_REQUEST",
  DELETE_SUPERADMIN_LIVE_VIDEO_SUCCESS: "DELETE_SUPERADMIN_LIVE_VIDEO_SUCCESS",
  DELETE_SUPERADMIN_LIVE_VIDEO_FAIL: "DELETE_SUPERADMIN_LIVE_VIDEO_FAIL",

  // Get live videos by course
  GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_REQUEST: "GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_REQUEST",
  GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_SUCCESS: "GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_SUCCESS",
  GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_FAIL: "GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_FAIL",

  // Get live videos by teacher
  GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_REQUEST: "GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_REQUEST",
  GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_SUCCESS: "GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_SUCCESS",
  GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_FAIL: "GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_FAIL",

  // Loading state
  SUPERADMIN_LIVE_VIDEOS_LOADING: "SUPERADMIN_LIVE_VIDEOS_LOADING",
}; 